import { render, staticRenderFns } from "./CorporationDialog.vue?vue&type=template&id=487b7193&scoped=true&"
import script from "./CorporationDialog.vue?vue&type=script&lang=js&"
export * from "./CorporationDialog.vue?vue&type=script&lang=js&"
import style0 from "./CorporationDialog.vue?vue&type=style&index=0&id=487b7193&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487b7193",
  null
  
)

export default component.exports